import React, { useState } from 'react';
import { Box, Container, Typography } from '@mui/material';
import PricingCards, { BillingCycle, PlanName } from '../components/PricingCards';
import { useNavigate } from 'react-router-dom';
import { useCurrentPlan } from '../hooks/useCurrentPlan';

const PricingPage: React.FC = () => {
  const navigate = useNavigate();
  const { data: plan } = useCurrentPlan();
  const [cycle, setCycle] = useState<BillingCycle>('YEARLY');
  const [selected, setSelected] = useState<PlanName | undefined>();

  const handleSelect = (p: PlanName) => {
    setSelected(p);
    // Phase 1: just navigate back; upgrade/checkout flow lands in Phase 3.
    navigate('/settings');
  };

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 } }}>
      <Box textAlign="center" mb={4}>
        <Typography variant="h3" fontWeight={800} gutterBottom>
          Pricing
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Choose the plan that fits your team.
        </Typography>
        {plan?.planName && (
          <Typography variant="caption" color="text.secondary" display="block" mt={1}>
            You are currently on the <strong>{plan.planName}</strong> plan.
          </Typography>
        )}
      </Box>
      <PricingCards
        cycle={cycle}
        onCycleChange={setCycle}
        selectedPlan={selected}
        onSelectPlan={handleSelect}
        ctaLabel="Choose"
      />
    </Container>
  );
};

export default PricingPage;
